import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {MUTATION_KEYS, queryClient, QUERY_KEYS} from '@/queryClient'
import {httpRegenerateActivityReport} from '@/features/accesses/activity-report/http/activityReport.http'
import {ActivityReport, ActivityReportError} from '@/features/accesses/activity-report/types'
import {invalidateActivityReportExportAvailability} from './invalidateActivityReportExportAvailability'

export const useRegenerateActivityReport = (
    options?: Omit<
        UseMutationOptions<ActivityReport, AxiosError<ActivityReportError>, {id: string}>,
        'mutationKey' | 'mutationFn'
    >
) =>
    useMutation({
        ...options,
        mutationKey: [MUTATION_KEYS.REGENERATE_ACTIVITY_REPORT],
        mutationFn: ({id}) => httpRegenerateActivityReport({id}),
        onSettled: (...args) => {
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.ACTIVITY_REPORTS]})
            invalidateActivityReportExportAvailability(queryClient)
            options?.onSettled?.(...args)
        }
    })
